'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { localStorageColorSchemeManager } from './color-scheme-managers/local-storage-manager.mjs';
import { MantineContext } from './Mantine.context.mjs';
import { MantineClasses } from './MantineClasses/MantineClasses.mjs';
import { MantineCssVariables } from './MantineCssVariables/MantineCssVariables.mjs';
import 'react';
import '@mantine/hooks';
import { MantineThemeProvider } from './MantineThemeProvider/MantineThemeProvider.mjs';
import { suppressNextjsWarning } from './suppress-nextjs-warning.mjs';
import { useProviderColorScheme } from './use-mantine-color-scheme/use-provider-color-scheme.mjs';
import { useRespectReduceMotion } from './use-respect-reduce-motion/use-respect-reduce-motion.mjs';
suppressNextjsWarning();
function MantineProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children,
    getStyleNonce = _ref.getStyleNonce,
    _ref$withStaticClasse = _ref.withStaticClasses,
    withStaticClasses = _ref$withStaticClasse === void 0 ? true : _ref$withStaticClasse,
    _ref$withGlobalClasse = _ref.withGlobalClasses,
    withGlobalClasses = _ref$withGlobalClasse === void 0 ? true : _ref$withGlobalClasse,
    _ref$deduplicateCssVa = _ref.deduplicateCssVariables,
    deduplicateCssVariables = _ref$deduplicateCssVa === void 0 ? true : _ref$deduplicateCssVa,
    _ref$withCssVariables = _ref.withCssVariables,
    withCssVariables = _ref$withCssVariables === void 0 ? true : _ref$withCssVariables,
    _ref$cssVariablesSele = _ref.cssVariablesSelector,
    cssVariablesSelector = _ref$cssVariablesSele === void 0 ? ":root" : _ref$cssVariablesSele,
    _ref$classNamesPrefix = _ref.classNamesPrefix,
    classNamesPrefix = _ref$classNamesPrefix === void 0 ? "mantine" : _ref$classNamesPrefix,
    _ref$colorSchemeManag = _ref.colorSchemeManager,
    colorSchemeManager = _ref$colorSchemeManag === void 0 ? localStorageColorSchemeManager() : _ref$colorSchemeManag,
    _ref$defaultColorSche = _ref.defaultColorScheme,
    defaultColorScheme = _ref$defaultColorSche === void 0 ? "light" : _ref$defaultColorSche,
    _ref$getRootElement = _ref.getRootElement,
    getRootElement = _ref$getRootElement === void 0 ? function () {
      return document.documentElement;
    } : _ref$getRootElement,
    cssVariablesResolver = _ref.cssVariablesResolver,
    forceColorScheme = _ref.forceColorScheme,
    stylesTransform = _ref.stylesTransform;
  var _useProviderColorSche = useProviderColorScheme({
      defaultColorScheme: defaultColorScheme,
      forceColorScheme: forceColorScheme,
      manager: colorSchemeManager,
      getRootElement: getRootElement
    }),
    colorScheme = _useProviderColorSche.colorScheme,
    setColorScheme = _useProviderColorSche.setColorScheme,
    clearColorScheme = _useProviderColorSche.clearColorScheme;
  useRespectReduceMotion({
    respectReducedMotion: (theme === null || theme === void 0 ? void 0 : theme.respectReducedMotion) || false,
    getRootElement: getRootElement
  });
  return /* @__PURE__ */jsx(MantineContext.Provider, {
    value: {
      colorScheme: colorScheme,
      setColorScheme: setColorScheme,
      clearColorScheme: clearColorScheme,
      getRootElement: getRootElement,
      classNamesPrefix: classNamesPrefix,
      getStyleNonce: getStyleNonce,
      cssVariablesResolver: cssVariablesResolver,
      cssVariablesSelector: cssVariablesSelector,
      withStaticClasses: withStaticClasses,
      stylesTransform: stylesTransform
    },
    children: /* @__PURE__ */jsxs(MantineThemeProvider, {
      theme: theme,
      children: [withCssVariables && /* @__PURE__ */jsx(MantineCssVariables, {
        cssVariablesSelector: cssVariablesSelector,
        deduplicateCssVariables: deduplicateCssVariables
      }), withGlobalClasses && /* @__PURE__ */jsx(MantineClasses, {}), children]
    })
  });
}
MantineProvider.displayName = "@mantine/core/MantineProvider";
function HeadlessMantineProvider(_ref2) {
  var children = _ref2.children,
    theme = _ref2.theme;
  return /* @__PURE__ */jsx(MantineContext.Provider, {
    value: {
      colorScheme: "auto",
      setColorScheme: function setColorScheme() {},
      clearColorScheme: function clearColorScheme() {},
      getRootElement: function getRootElement() {
        return document.documentElement;
      },
      classNamesPrefix: "mantine",
      cssVariablesSelector: ":root",
      withStaticClasses: false,
      headless: true
    },
    children: /* @__PURE__ */jsx(MantineThemeProvider, {
      theme: theme,
      children: children
    })
  });
}
HeadlessMantineProvider.displayName = "@mantine/core/HeadlessMantineProvider";
export { HeadlessMantineProvider, MantineProvider };